import conn from "@/store/utils/connection";
import resulter from "@/store/utils/resulter";
import api from "../apiEndPoint";

export default {
    getListOutlet: ({ commit }, { iddevice }) => {
        let query = {
            offset: 0,
            limit: 100,
        };

        if (iddevice !== null) {
            query.iddevice = iddevice;
        }

        conn.get(api.getListOutlet, query)
            .then((res) => {
                let { code, data, status, msg } = res.data;
                if (code === 200 && status) {
                    commit("setListOutlet", data);
                    commit("setEndOutlet", data.array[data.array.length - 1]);
                    commit("setNextPageOutlet", data);
                    commit("setResponse", resulter.successResult(msg));
                } else {
                    commit("setResponse", resulter.errorResult(msg));
                }
                commit("setFetching", false);
            })
            .catch((e) => {
                commit("setFetching", false);
                commit("setResponse", resulter.errorResult(e));
            });
    },
    getListDeviceTiny: ({ commit, dispatch }) => {
        let query = {
            offset: 0,
            limit: 100,
        };
        commit("setFetching", true);
        commit("setResponse", {});
        conn.get(api.getListDeviceTiny, query)
            .then((res) => {
                let { code, data, status, msg } = res.data;
                if (code === 200 && status) {
                    commit("setListDeviceTiny", data.array);
                    dispatch("getListOutletFree");
                } else {
                    commit("setResponse", resulter.errorResult(msg));
                    commit("setFetching", false);
                }
            })
            .catch((e) => {
                commit("setFetching", false);
                commit("setResponse", resulter.errorResult(e));
            });
    },
    getListOutletFree: ({ commit }) => {
        conn.get(api.getListOutletFree)
            .then((res) => {
                let { code, data, status, msg } = res.data;
                if (code === 200 && status) {
                    commit("setListOutletFree", data.array);
                    commit("setResponse", resulter.successResult(msg));
                } else {
                    commit("setResponse", resulter.errorResult(msg));
                }
                commit("setFetching", false);
            })
            .catch((e) => {
                commit("setFetching", false);
                commit("setResponse", resulter.errorResult(e));
            });
    },
    integrasiOutlet: ({ commit }, payload) => {
        commit("setFetching", true);
        commit("setResponse", {});
        let posted = new FormData();

        Object.keys(payload).forEach(function(key) {
            posted.append(key, payload[key]);
        });

        return conn.post(api.integrasiOutlet, posted, conn.contentType.form);
    },
    unlinkOutlet: ({ commit }, payload) => {
        commit("setFetching", true);
        commit("setResponse", {});

        let posted = new FormData();

        Object.keys(payload).forEach(function(key) {
            posted.append(key, payload[key]);
        });

        return conn.post(api.unlinkOutlet, posted, conn.contentType.form);
    },
    getSettingWa: ({ commit }, { idoutlet }) => {
        let query = {
            idoutlet,
        };
        commit("setFetching", true);
        commit("setResponse", {});
        conn.get(api.getSettingWa, query)
            .then((res) => {
                let { code, data, status, msg } = res.data;
                if (code === 200 && status) {
                    commit("settingOutlet", data);
                    commit("setResponse", resulter.successResult(msg));
                }
                commit("setFetching", false);
            })
            .catch((e) => {
                commit("setFetching", false);
                commit("setResponse", resulter.errorResult(e));
            });
    },
    changeDevice: ({ commit }, payload) => {
        let posted = new FormData();
        Object.keys(payload).forEach(function(key) {
            posted.append(key, payload[key]);
        });
        commit("setFetching", true);
        commit("setResponse", {});
        return conn.post(api.changeDevice, posted, conn.contentType.form);
    },
    changeSettingTemplate: ({ commit }, payload) => {
        let posted = new FormData();
        Object.keys(payload).forEach(function(key) {
            posted.append(key, payload[key]);
        });
        commit("setFetching", true);
        return conn.post(api.changeSettingTemplate, posted, conn.contentType.form);
    },
    getDetailTemplatePesan: ({ commit }, { idoutlet, idpayload }) => {
        let query = {
            idoutlet,
            idpayload,
        };
        commit("setFetching", true);
        commit("setResponse", {});
        conn.get(api.getDetailTemplatePesan, query)
            .then((res) => {
                let { code, data, status, msg } = res.data;
                if (code === 200 && status) {
                    commit("setDetailTemplatePesan", data);
                    commit("setResponse", resulter.successResult(msg));
                }
                commit("setFetching", false);
            })
            .catch((e) => {
                commit("setFetching", false);
                commit("setResponse", resulter.errorResult(e));
            });
    },
    resetDetailTemplatePesan: ({ commit }) => {
        commit("setDetailTemplatePesan", {});
    },
    resetTemplatePesan: ({ commit }, payload) => {
        let posted = new FormData();
        Object.keys(payload).forEach(function(key) {
            posted.append(key, payload[key]);
        });
        commit("setFetching", true);
        return conn.post(api.resetTemplatePesan, posted, conn.contentType.form);
    },
    updateTemplate: ({ commit }, payload) => {
        let posted = new FormData();
        Object.keys(payload).forEach(function(key) {
            posted.append(key, payload[key]);
        });
        commit("setFetching", true);
        return conn.post(api.updateTemplate, posted, conn.contentType.form);
    },
};
